// @flow
import React from 'react';
import FocusedImage from 'Components/FocusedImage';
import AssetModel from 'Stores/AssetModel';
import Link from 'Components/Link';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

type Props = {
  title?: string,
  description?: string,
  placeholder: Node,
  image: AssetModel,
  roundImage: boolean,
  href?: string,
  children: Node,
  onClick?: () => void,
};

export class ImageBox extends React.Component<Props> {
  static defaultProps = {
    placeholder: null,
  };

  renderImage(image: AssetModel, title: string) {
    if (image) {
      let alt = image.alt;

      if (title) {
        alt = `Portrait von ${title}`;
      }
      return <FocusedImage image={{ ...image, alt }} />;
    }

    return this.props.placeholder;
  }

  render() {
    const { title, description, image, href, onClick, roundImage, children } = this.props;

    const rootClass = cx('box', {
      link: href || onClick,
      roundImage,
    });

    // Workaround: Wir verschieben die Team-Bilder aus dem Altdatenimport manuell nach unten, um
    // die Gesichter besser im Container zu zentrieren.
    if (image && image.focus.x === 0 && image.focus.y === 0) {
      image.focus.y = 0.5;
    }

    const renderImageBox = (
      <>
        <div className={styles.image} key="image">
          {this.renderImage(image, title)}
        </div>
        <div className={styles.content} key="content">
          {title && <div className={styles.title}>{title}</div>}
          {description && <div className={styles.description}>{description}</div>}
          {children}
        </div>
      </>
    );

    if (href) {
      return (
        <li className={rootClass}>
          <Link to={href}>{renderImageBox}</Link>
        </li>
      );
    }

    return (
      <li className={rootClass} onClick={onClick}>
        {renderImageBox}
      </li>
    );
  }
}
